var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Stack, styled, Tab, Tabs } from "@mui/material";
import { allCategories } from "../util/categorias";
import { FormButton, FormButtonType } from "./FormButton";
import AppBarHeader from "./Home/AppBarHeader";
import { Search } from "./Home/Search";
import { Modal } from "./Modal";
var StyledTabs = styled(function (props) { return (_jsx(Tabs, __assign({}, props, { TabIndicatorProps: { children: _jsx("span", { className: "MuiTabs-indicatorSpan" }) } }))); })({
    "& .MuiTabs-indicator": {
        display: "flex",
        justifyContent: "center",
        backgroundColor: "transparent",
    },
    "& .MuiTabs-indicatorSpan": {
        maxWidth: 80,
        width: "100%",
        backgroundColor: "white",
    },
});
var StyledTab = styled(function (props) { return (_jsx(Tab, __assign({ disableRipple: true }, props))); })(function () { return ({
    color: "white",
    "&.Mui-selected": {
        color: "white",
    },
}); });
export var FixedMenu = function (_a) {
    var title = _a.title, isHabilitacao = _a.isHabilitacao, _b = _a.goBackTo, goBackTo = _b === void 0 ? "/home" : _b;
    var navigate = useNavigate();
    var _c = useState(), cancelBySearch = _c[0], setCancelBySearch = _c[1];
    var _d = useState(), cancelByCategory = _d[0], setCancelByCategory = _d[1];
    var _e = useState(3), value = _e[0], setValue = _e[1];
    var search = function (value) {
        if (value) {
            navigate("/home/".concat(value));
        }
    };
    var changeCategory = function (value) {
        if (value !== undefined) {
            navigate("/home/".concat(undefined, "/").concat(value));
        }
    };
    var handleChange = function (event, newValue) {
        if (!isHabilitacao) {
            setValue(newValue);
            changeCategory(newValue);
        }
        else {
            setCancelByCategory(newValue);
        }
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Stack, __assign({ sx: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    zIndex: 1000,
                    backgroundColor: "white",
                } }, { children: [_jsx(AppBarHeader, { titulo: title, isHome: true, voltarPara: goBackTo }), _jsxs(Stack, __assign({ mt: "-8rem", gap: "1rem", justifyContent: "center", alignItems: "center" }, { children: [_jsx(Search, { onSearch: function (value) {
                                    isHabilitacao ? setCancelBySearch(value) : search(value);
                                }, onClearSearch: function () { return null; } }), _jsx(Box, __assign({ sx: {
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: "center",
                                } }, { children: _jsx(StyledTabs, __assign({ value: value, onChange: handleChange, "aria-label": "home tabs" }, { children: allCategories.map(function (category) { return (_jsx(StyledTab, { label: category.title }, category.id)); }) })) }))] }))] })), _jsx(Modal, { open: !!cancelBySearch, onClose: function () { return setCancelBySearch(undefined); }, title: "Cancelar solicita\u00E7\u00E3o", subTitle: "Deseja cancelar e seguir com a busca?", buttons: [
                    _jsx(FormButton, { type: FormButtonType.CANCEL_PRIMARY, title: "Sim", onClick: function () { return search(cancelBySearch); } }),
                    _jsx(FormButton, { type: FormButtonType.CANCEL_SECONDARY, title: "N\u00E3o", onClick: function () { return setCancelBySearch(undefined); } }),
                ] }), _jsx(Modal, { open: cancelByCategory !== undefined, onClose: function () { return setCancelByCategory(undefined); }, title: "Cancelar solicita\u00E7\u00E3o", subTitle: "Deseja cancelar e seguir com a busca?", buttons: [
                    _jsx(FormButton, { type: FormButtonType.CANCEL_PRIMARY, title: "Sim", onClick: function () { return changeCategory(cancelByCategory); } }),
                    _jsx(FormButton, { type: FormButtonType.CANCEL_SECONDARY, title: "N\u00E3o", onClick: function () { return setCancelByCategory(undefined); } }),
                ] })] }));
};
